import { SvgIcon, SvgIconProps } from "@mui/material"

function EditIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M23.1202 2.63719L21.3619 0.878906C20.7764 0.292969 20.0086 0 19.2408 0C18.473 0 17.7052 0.292969 17.1192 0.878438L0.601415 17.3962L0.00610149 22.7503C-0.0688986 23.4244 0.462196 24 1.12173 24C1.16345 24 1.20517 23.9977 1.24782 23.993L6.59814 23.4019L23.1207 6.87937C24.2921 5.70797 24.2921 3.80859 23.1202 2.63719ZM5.90955 21.9694L1.54876 22.4527L2.03439 18.0853L14.4042 5.71547L18.2841 9.59531L5.90955 21.9694ZM22.0599 5.81906L19.3444 8.53453L15.4646 4.65469L18.18 1.93922C18.4632 1.65609 18.84 1.5 19.2408 1.5C19.6416 1.5 20.018 1.65609 20.3016 1.93922L22.0599 3.6975C22.6444 4.2825 22.6444 5.23406 22.0599 5.81906Z"/>
        </SvgIcon>
    )
}

export default EditIcon